import { Button } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SkipModal from "../../modals/SkipModal";

const CreateProfileFooter = ({
  IS_ABOUT,
  IS_EDITABLE,
  handleEditableStep,
  editableStep,
  savingsObj,
  emptySavingObj,
  formik,
  IS_SKIPPABLE,
  handleNextStep,
  innerStepper,
  checkSubmitDisabled,
  IS_INCOME,
  debtObj,
  emptyDebtObj,
  checkConfirmDisabled,
  IS_REVIEW,
  onFinish,
}) => {
  const [open, setOpen] = useState(false);
  const [skipContent, setSkipContent] = useState("");
  const { t } = useTranslation();
  const userData = useSelector((state) => state.form.userData);
  const skipModal = (visible) => {
    setOpen(visible);
  };
  return IS_ABOUT ? (
    <>
      <div
        className={`footer-row row mx-0 align-items-center ${
          IS_SKIPPABLE ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {IS_SKIPPABLE && (
          <Button onClick={() => skipModal(true)} className="skip-btn">
            {t("skipBtn")}
          </Button>
        )}
        {(IS_EDITABLE || IS_REVIEW) && editableStep ? (
          <Button
            className="auth-theme-btn auth-theme-btn-outline theme-inner-btn d-flex align-items-center"
            disabled={checkConfirmDisabled()}
            onClick={(e) => {
              e.preventDefault();
              const isChildSelected = formik.values.houseHold?.find(
                (i) => i.type === "children"
              );
              const isOtherSelected = formik.values.houseHold?.find(
                (i) => i.type === "otherMembers"
              );
              let errorFlags = {
                child: false,
                others: false,
              };
              if (isChildSelected) {
                if (formik.values.children > 10) {
                  formik.setFieldError(
                    "children",
                    t("aboutYou.ques8.options.err1")
                  );
                  errorFlags.child = true;
                } else if (formik.values.children === 0) {
                  formik.setFieldError(
                    "children",
                    t("aboutYou.ques8.requiredMsg")
                  );
                  errorFlags.child = true;
                } else {
                  errorFlags.child = false;
                }
              }
              if (isOtherSelected) {
                if (formik.values.otherMembers > 10) {
                  formik.setFieldError(
                    "otherMembers",
                    t("aboutYou.ques8.options.err2")
                  );
                  errorFlags.others = true;
                } else if (formik.values.otherMembers === 0) {
                  formik.setFieldError(
                    "otherMembers",
                    t("aboutYou.ques8.requiredMsg")
                  );
                  errorFlags.others = true;
                } else {
                  errorFlags.others = false;
                }
              }
              if (!errorFlags.child && !errorFlags?.others) {
                handleEditableStep(null);
              }
            }}
          >
            {t("confirmBtn")}
          </Button>
        ) : (
          <Button
            className={`auth-theme-btn theme-inner-btn d-flex align-items-center ${
              innerStepper ? "w-auto" : ""
            }`}
            htmlType="submit"
            disabled={checkSubmitDisabled()}
          >
            {innerStepper !== 7 ? t("nextBtn") : t("confirmSave")}
            <img
              src="/assets/images/icons/arrow-right-white.svg"
              alt=""
              className="img-fluid arrow-right-icon"
            />
          </Button>
        )}
      </div>
      <SkipModal
        open={open}
        onClose={() => skipModal(false)}
        handleNextStep={handleNextStep}
        onFinish={onFinish}
      />
    </>
  ) : innerStepper <= 6 && IS_INCOME ? (
    <>
      <div
        className={`footer-row row mx-0 align-items-center ${
          IS_SKIPPABLE ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {IS_SKIPPABLE && (
          <Button
            onClick={() => {
              skipModal(true);
              setSkipContent(
                `<h1>${t("income.ques6.skipTitle")}<h1> <p>${t(
                  "income.ques6.skipDesc"
                )}<p>`
              );
            }}
            className="skip-btn"
          >
            {t("skipBtn")}
          </Button>
        )}
        {(IS_EDITABLE || IS_REVIEW) && editableStep ? (
          <Button
            className="auth-theme-btn auth-theme-btn-outline theme-inner-btn d-flex align-items-center"
            onClick={(e) => {
              e.preventDefault();
              handleEditableStep(null);
              if (editableStep === 4 || editableStep === 5) {
                onFinish();
              }
            }}
            disabled={checkConfirmDisabled()}
          >
            {t("confirmBtn")}
          </Button>
        ) : (
          <Button
            className="auth-theme-btn theme-inner-btn d-flex align-items-center"
            htmlType="submit"
            disabled={checkSubmitDisabled()}
          >
            {innerStepper !== 6 ? t("nextBtn") : t("confirmSave")}
            <img
              src="/assets/images/icons/arrow-right-white.svg"
              alt=""
              className="img-fluid arrow-right-icon"
            />
          </Button>
        )}
      </div>
      <SkipModal
        open={open}
        onClose={() => skipModal(false)}
        handleNextStep={handleNextStep}
        innerStepper={innerStepper}
        formik={formik}
        IS_INCOME={IS_INCOME}
        handleEditableStep={handleEditableStep}
        skipContent={skipContent}
        onFinish={onFinish}
      />
    </>
  ) : (
    <>
      <div
        className={`footer-row row mx-0 align-items-center ${
          IS_SKIPPABLE ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {IS_SKIPPABLE && (
          <Button
            onClick={() => {
              skipModal(true);
              if (innerStepper === 11) {
                if (userData?.livingInCanada === "yes") {
                  setSkipContent(
                    `<h1>${t("expenses.skipContent.2.child1")}<h1> <p>${t(
                      "expenses.skipContent.2.child2"
                    )}<p>`
                  );
                } else {
                  setSkipContent(
                    "<h1>Are you sure you want to skip this question?<h1> <p>Think about how you’ll get around in Canada. Will you use the bus to get to work or appointments? Maybe you’ll take Ubers or taxis. Factor in those costs here.<p>"
                  );
                }
              } else if (innerStepper === 3) {
                setSkipContent(
                  `<h1>${t("expenses.skipContent.1.child1")}<h1> <p>${t(
                    "expenses.skipContent.1.child2"
                  )}<p>`
                );
              } else if (innerStepper === 15) {
                setSkipContent(
                  `<p style="margin-top:25px;">${t(
                    "expenses.skipContent.4.child1"
                  )}<br/>${t("expenses.skipContent.4.child2")}</p>`
                );
              } else {
                setSkipContent(
                  `<h1>${t("expenses.skipContent.3.child1")}</h1> <p>${t(
                    "expenses.skipContent.3.child2"
                  )}</p>`
                );
              }
            }}
            className="skip-btn"
          >
            {t("skipBtn")}
          </Button>
        )}
        {(IS_REVIEW || IS_EDITABLE) && editableStep ? (
          <Button
            className="auth-theme-btn auth-theme-btn-outline theme-inner-btn d-flex align-items-center"
            disabled={checkConfirmDisabled()}
            onClick={(e) => {
              e.preventDefault();
              handleEditableStep(null);
              if (
                editableStep === 14 ||
                editableStep === 17 ||
                editableStep === 19
              ) {
                onFinish();
              }
            }}
          >
            {t("confirmBtn")}
          </Button>
        ) : (
          <Button
            className="auth-theme-btn theme-inner-btn d-flex align-items-center"
            htmlType="submit"
            disabled={checkSubmitDisabled()}
          >
            {innerStepper !== 20 ? t("nextBtn") : t("confirmSave")}
            <img
              src="/assets/images/icons/arrow-right-white.svg"
              alt=""
              className="img-fluid arrow-right-icon"
            />
          </Button>
        )}
      </div>
      <SkipModal
        open={open}
        onClose={() => skipModal(false)}
        handleNextStep={handleNextStep}
        innerStepper={innerStepper}
        formik={formik}
        skipContent={skipContent}
        IS_EXPENSES
        handleEditableStep={handleEditableStep}
        onFinish={onFinish}
      />
    </>
  );
};

export default CreateProfileFooter;
